/* ——————————————————————————————————————————
   TERRASTRATAS • MAP BUILDER SCRIPT  v1.2
   – keeps price in sync with variants/qty
   – fires a resize so the map appears
——————————————————————————————————————— */
document.addEventListener('DOMContentLoaded', () => {
  /* frequently-used DOM nodes */
  const toggle        = document.getElementById('toggleBuilder');
  const panel         = document.getElementById('builderPanel');
  const addBtn        = document.getElementById('addToCartBtn');
  const priceDisplay  = document.getElementById('builderPrice');
  const variantHidden = document.getElementById('variantId');
  const qtyInput      = document.getElementById('quantity');

  if (!toggle || !panel) return;              // exit on non-map products

  /* ---------- helpers ---------- */
  function updateBuilderPrice () {
  /* price now handled by Shopify’s native display, so nothing to update */
}


  function syncVariant () {
    const liveVariant = document.querySelector('input[name="id"]');
    if (liveVariant) variantHidden.value = liveVariant.value;
    updateBuilderPrice();
  }

  /* ---------- show / hide builder ---------- */
  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));

    if (!open) {                               // opening
      panel.hidden = false;
      panel.style.maxHeight = panel.scrollHeight + 'px';
      setTimeout(() =>
        panel.scrollIntoView({ behavior: 'smooth' }), 150);

      updateBuilderPrice();

      /* 🔄 force Google Maps to redraw now that div has height */
      setTimeout(() => {
        if (window.google && window.google.maps && map) {
          google.maps.event.trigger(map, 'resize');
        }
      }, 350);
    } else {                                   // closing
      panel.style.maxHeight = '0';
      setTimeout(() => { panel.hidden = true; }, 500);
    }
  });

  /* ---------- keep price in sync ---------- */
  document.addEventListener('change', syncVariant);        // frame/size pills
  qtyInput.addEventListener('input', updateBuilderPrice);  // quantity
  syncVariant();                                           // run once on load

  /* ---------- Google Map ---------- */
  let map, rectangle;

  window.initializeMap = () => {
    map = new google.maps.Map(
      document.getElementById('mapCanvas'),
      {
        center: { lat: 39.8283, lng: -98.5795 },
        zoom:   4,
        mapTypeId: 'terrain',
        streetViewControl: false
      }
    );

    /* place-search box */
    const input     = document.getElementById('map-search');
    const searchBox = new google.maps.places.SearchBox(input);
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

    map.addListener('bounds_changed', () =>
      searchBox.setBounds(map.getBounds())
    );

    searchBox.addListener('places_changed', () => {
      const places = searchBox.getPlaces();
      if (!places.length) return;
      const bounds = new google.maps.LatLngBounds();
      places.forEach(p =>
        p.geometry?.viewport ? bounds.union(p.geometry.viewport)
                             : bounds.extend(p.geometry.location)
      );
      map.fitBounds(bounds);
    });
  };

  /* ---------- draw / clear / confirm box ---------- */
  function drawBoundingBox () {
    if (rectangle) rectangle.setMap(null);

    const b = map.getBounds(); if (!b) return;
    const ne = b.getNorthEast(), sw = b.getSouthWest();
    const c  = map.getCenter();
    const latPad = (ne.lat() - sw.lat()) * 0.25;
    const lngPad = (ne.lng() - sw.lng()) * 0.25;

    rectangle = new google.maps.Rectangle({
      bounds: {
        north: c.lat() + latPad, south: c.lat() - latPad,
        east:  c.lng() + lngPad, west:  c.lng() - lngPad
      },
      editable: true, draggable: true, map,
      strokeColor: '#ff0000', strokeOpacity: 1,
      fillColor:   '#ff0000', fillOpacity: 0.05
    });
  }

  function clearBoundingBox () {
    if (!rectangle) return;
    rectangle.setMap(null); rectangle = null;
    addBtn.disabled = true;
    addBtn.classList.add('opacity-50', 'pointer-events-none');
  }

  function confirmBoundingBox () {
    if (!rectangle) { alert('⚠️ Draw a bounding box first.'); return; }
    rectangle.setEditable(false);
    rectangle.setDraggable(false);

    const b  = rectangle.getBounds();
    const ne = b.getNorthEast(), sw = b.getSouthWest();

    document.getElementById('bounding-box-ne').value =
      `${ne.lat().toFixed(6)}, ${ne.lng().toFixed(6)}`;
    document.getElementById('bounding-box-sw').value =
      `${sw.lat().toFixed(6)}, ${sw.lng().toFixed(6)}`;
    document.getElementById('selected-area').value =
      document.getElementById('map-search').value;

    document.dispatchEvent(new Event('map:confirmed'));
  }

  /* ---------- hook up buttons ---------- */
  document.getElementById('draw-box')   .onclick = drawBoundingBox;
  document.getElementById('clear-map')  .onclick = clearBoundingBox;
  document.getElementById('confirm-box').onclick = confirmBoundingBox;

  /* unlock Add-to-Cart when box confirmed */
  document.addEventListener('map:confirmed', () => {
    addBtn.disabled = false;
    addBtn.classList.remove('opacity-50', 'pointer-events-none');
  });
});
